import { useTranslation } from "react-i18next";
// utils
import localStorageAvailable from "../utils/localStorageAvailable";
// components
import { useSettingsContext } from "../components/settings";
//
import { defaultLang } from "./config-lang";
import { useSelector } from "../redux/store";
import { useDispatch } from "react-redux";
import { updateLanguage } from "../redux/slices/config";
import { useAuthContext } from "src/auth/useAuthContext";
// ----------------------------------------------------------------------

export default function useLocales() {
  const { i18n, t } = useTranslation();
  const { user, setUser } = useAuthContext();

  const dispatch = useDispatch();

  const { onChangeDirectionByLang } = useSettingsContext();

  const storageAvailable = localStorageAvailable();

  const { languages } = useSelector((state) => state.config);

  const langStorage = storageAvailable
    ? localStorage.getItem("i18nextLng")
    : "";

  const currentLang =
    languages.find((_lang) => _lang.lang_code === langStorage) || defaultLang;

  const handleChangeLanguage = async (newlang) => {
    i18n.changeLanguage(newlang);
    onChangeDirectionByLang(newlang);

    if (user) {
      const response = await dispatch(updateLanguage(newlang)).unwrap();
      const userUpdatedData = {
        ...user,
        user: { ...response },
      };
      setUser(userUpdatedData);
    }
  };

  return {
    onChangeLang: handleChangeLanguage,
    t: (text, options) => t(text, options),
    currentLang,
    languages,
  };
}
